export const PRINTED_NAME_MAX_LENGTH = 100;
